import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BackofficeCartridgeService } from '@markant-platform/backoffice/data-access';
import { BookingState } from '@markant-platform/cartridge/model';
import { firstValueFrom } from 'rxjs';

type ServiceDocumentFilter = {
  documentFilters: {
    category: string[];
  };
  cartridgeVariantId?: string[];
};

@Component({
  selector: 'markant-platform-management-tile-service-documents',
  templateUrl: './service-documents.component.html',
  styleUrls: ['./service-documents.component.scss'],
})
export class ServiceDocumentsManagementTileComponent implements OnChanges {
  @Input() priceRequestId?: string;
  @Input({ required: true }) variantId!: string;
  @Input({ required: true }) bookingState!: BookingState;

  filterInvoiceState: ServiceDocumentFilter = {
    documentFilters: {
      category: ['INVOICE'],
    },
  };

  filterServiceConditionsState: ServiceDocumentFilter = {
    documentFilters: {
      category: ['SERVICE_CONDITIONS'],
    },
  };

  constructor(private cartridgeService: BackofficeCartridgeService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['variantId']) {
      this.filterInvoiceState.cartridgeVariantId = [this.variantId];
      this.filterServiceConditionsState.cartridgeVariantId = [this.variantId];
    }
  }

  async showOfferDocument(): Promise<void> {
    if (this.priceRequestId) {
      const url = await firstValueFrom(this.cartridgeService.getOfferDocumentPreviewAsUrl(this.priceRequestId));
      window.open(url);
    }
  }
}
